import React, { useState } from "react";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import { FormControl, FormHelperText, Stack } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import MaterialSelect from "../../components/MasterSelect";
import { isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";

const OnsiteEmployeeDetails = ({
  employeeData,
  setEmployeeData,
  inputDisbled,

  setIsValidPhone,
}) => {
  const employeeDataChange = (e, select) => {
    const inputname = e?.target?.name;
    const values = e?.target?.value;

    const temp = { ...employeeData };

    if (select) {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(e?.label) === true) {
        temp["typeStatus"] = e?.label === undefined ? "unchecked" : "success";
      } else {
        temp["typeStatus"] = temp["type"] === "" ? "unchecked" : "error";
      }
      temp["type"] = e;
    } else {
      if (inputname == "employeeName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      } else if (inputname == "employeeId") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      } else if (inputname == "email") {
        const lengthRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      } else if (inputname == "passportNo") {
        const lengthRegex = /^[A-Za-z0-9]{6,9}$/;

        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      } else if (inputname == "experience") {
        const lengthRegex = /^(?!\s*$)[^\s]+$/;

        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      } else if (inputname == "joiningDate") {
        const lengthRegex = /^.+$/;

        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      } 
      else if (inputname == "projectName") {
        const lengthRegex = /^.+$/;

        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      }
      else if (inputname == "phoneNo") {
        const lengthRegex = /^[0-9]{8,15}$/;

        if (lengthRegex.test(values) === true) {
          temp[inputname + "Status"] =
            values === undefined ? "unchecked" : "success";
        } else {
          temp[inputname + "Status"] = values === "" ? "unchecked" : "error";
        }
      }
      temp[inputname] = e?.target?.value;
    }

    setEmployeeData(temp);
  };
  const [countryCode, setCountryCode] = useState('in');
  // const employeePhoneChange = (v) => {
  //   setEmployeeData({ ...employeeData, phoneNo: v });
  // };

 
  // const employeePhoneChange = (value, country) => {
  //   setEmployeeData((prev) => ({
  //     ...prev,
  //     phoneNo: value,
  //   }));
  
  //   if (country?.countryCode?.toUpperCase() === "IN") {
  //     const phoneNumber = parsePhoneNumberFromString(value, "IN");
  
  //     if (phoneNumber && phoneNumber.isValid() && phoneNumber.nationalNumber.length === 10) {
  //       setIsValidPhone(true);  // ✅ Valid Indian mobile number
  //     } else {
  //       setIsValidPhone(false); // ❌ Invalid Indian number (too short/long)
  //     }
  //   } else {
  //     // For other countries, use standard validation
  //     if (isValidPhoneNumber(value, country?.countryCode?.toUpperCase())) {
  //       setIsValidPhone(true);
  //     } else {
  //       setIsValidPhone(false);
  //     }
  //   }
  // };

  // const maxLengths = {
  //   us: 10, // USA
  //   in: 10, // India
  //   uk: 10, // UK
  //   fr: 9,  // France
  //   de: 11, // Germany
  //   au: 9,  // Australia
  //   ca: 10, // Canada
  //   cn: 11, // China
  //   jp: 10, // Japan
  //   br: 11, // Brazil
  //   mx: 10, // Mexico
  //   ru: 10, // Russia
  //   za: 9,  // South Africa
  //   ar: 10, // Argentina
  //   it: 10, // Italy
  //   es: 9,  // Spain
  //   nl: 9,  // Netherlands
  //   tr: 10, // Turkey
  //   kr: 11, // South Korea
  //   id: 11, // Indonesia
  //   sg: 8,  // Singapore
  //   my: 10, // Malaysia
  //   th: 9,  // Thailand
  //   ph: 10, // Philippines
  //   vn: 10, // Vietnam
  //   pk: 10, // Pakistan
  //   bd: 11, // Bangladesh
  //   ng: 10, // Nigeria
  //   eg: 11, // Egypt
  //   ir: 10, // Iran
  //   iq: 10, // Iraq
  //   sa: 9,  // Saudi Arabia
  //   ae: 9,  // UAE
  //   il: 9,  // Israel
  //   ch: 9,  // Switzerland
  //   be: 9,  // Belgium
  //   at: 10, // Austria
  //   se: 9,  // Sweden
  //   no: 8,  // Norway
  //   fi: 10, // Finland
  //   dk: 8,  // Denmark
  //   bh: 8,  // Bahrain (XXXX XXXX)
  // };
 
  // const handlePhoneChange = (value, country) => {
  //   const maxLength = maxLengths[country?.countryCode] || 15; // Default max length: 15
  //   const formattedPhone = value.replace(/\D/g, '');
 
  //   if (formattedPhone.length <= maxLength) {
  //     // setPhone(value);
  //     setEmployeeData({ ...employeeData, phoneNo: value });
  //     setIsValidPhone(false)
  //   }else{
     
  //     setIsValidPhone(true)
  //   }
  //   setCountryCode(country.countryCode);
   
  // };
  

  const typeOption = ["Employee", "Consultant"];

  return (
    <>
      <Stack direction="row" spacing={1}>
        <MaterialTypography component="label" variant="body2" fontWeight="bold">
          Employee Details
        </MaterialTypography>
      </Stack>
      <MaterialBox>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Employee Type <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialSelect
              name="type"
              value={employeeData.type}
              defaultValue={{ label: "Please select" }}
              customStyles={{ optionPadding: 20 }}
              onChange={employeeDataChange}
              options={typeOption?.map((value) => {
                return {
                  value: value,
                  label: value,
                };
              })}
              error={employeeData.typeStatus === "error" ? true : false}
              success={employeeData.typeStatus === "success" ? true : false}
              isDisabled={inputDisbled}
            />
            {employeeData.typeStatus === "error" && (
              <FormControl error>
                <FormHelperText>Employee Type is mandatory.</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Employee Name / Consultant Name{" "}
                <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="employeeName"
              placeholder="Enter Employee Name"
              value={employeeData?.employeeName}
              onChange={employeeDataChange}
              error={employeeData?.employeeNameStatus === "error"}
              success={employeeData?.employeeNameStatus === "success"}
              disabled={inputDisbled}
            />
            {employeeData?.employeeNameStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Accept only numbers and alphabetic characters.
                </FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Employee ID / Consultant ID{" "}
                <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="employeeId"
              placeholder="Enter Employee ID"
              onChange={employeeDataChange}
              value={employeeData?.employeeId}
              error={employeeData?.employeeIdStatus === "error"}
              success={employeeData?.employeeIdStatus === "success"}
              disabled={inputDisbled}
            />
            {employeeData?.employeeIdStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Accept only numbers and alphabetic characters.
                </FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Mobile Number <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
            type="number"
              name="phoneNo"
              placeholder="Enter phone number"
              value={employeeData?.phoneNo}
              onChange={employeeDataChange}
              error={employeeData?.phoneNoStatus === "error"}
              success={employeeData?.phoneNoStatus === "success"}
              disabled={inputDisbled}
            />
            {/* <div>
              <PhoneInput
                value={employeeData.phoneNo}
                onChange={handlePhoneChange}
                country={"in"}
                name="phoneNo"
                countryCodeEditable={inputDisbled}
                disableDropdown={inputDisbled}
                defaultCountry="in"
                inputProps={{
                  // maxLength:10,
                  required: true,
                  disabled: inputDisbled,
                  placeholder: "",
                  style: {
                    borderRadius: "8px",
                    border: "0.0625rem solid grey",
                    height: "40px",
                    paddingLeft: "48px",
                    width: "100%",
                  },
                }}
                containerStyle={{
                  borderRadius: "8px",
                  width: "100%",
                }}
                buttonStyle={{
                  border: "none",
                  backgroundColor: "transparent",
                  borderRadius: "8px 0 0 8px",
                }}
                inputStyle={{
                  borderRadius: "0 8px 8px 0",
                  fontSize: "14px",
                }}
              />
            </div> */}
              {employeeData?.phoneNoStatus === "error" && (
              <FormControl error>
                <FormHelperText>Phone number must contain only 8 to 15 digits.</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Mail ID <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="email"
              placeholder="Enter Mail ID"
              onChange={employeeDataChange}
              value={employeeData?.email}
              error={employeeData?.emailStatus === "error"}
              success={employeeData?.emailStatus === "success"}
              disabled={inputDisbled}
            />
            {employeeData?.emailStatus === "error" && (
              <FormControl error>
                <FormHelperText>Invalid email address</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Passport Number <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="passportNo"
              placeholder="Enter Passport Number"
              onChange={employeeDataChange}
              value={employeeData?.passportNo}
              error={employeeData?.passportNoStatus === "error" ? true : false}
              success={
                employeeData?.passportNoStatus === "success" ? true : false
              }
              disabled={inputDisbled}
            />
            {employeeData?.passportNoStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Passport must be 6 to 9 characters long and contain only
                  letters and numbers.
                </FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Experience <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              type="number"
              name="experience"
              placeholder="Enter Experience"
              onChange={employeeDataChange}
              value={employeeData?.experience}
              error={employeeData?.experienceStatus === "error"}
              success={employeeData?.experienceStatus === "success"}
              disabled={inputDisbled}
            />
            {employeeData?.experienceStatus === "error" && (
              <FormControl error>
                <FormHelperText>Experience is mandatory.</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Joining Date <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="joiningDate"
              type="date"
              placeholder="Enter Joining Date"
              onChange={employeeDataChange}
              value={employeeData?.joiningDate}
              error={employeeData?.joiningDateStatus === "error" ? true : false}
              success={
                employeeData?.joiningDateStatus === "success" ? true : false
              }
              disabled={inputDisbled}
            />
            {employeeData?.joiningDateStatus === "error" && (
              <FormControl error>
                <FormHelperText>Joining Date is mandatory.</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Project Name <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="projectName"
              placeholder="Enter Project Name"
              onChange={employeeDataChange}
              value={employeeData?.projectName}
              error={employeeData?.projectNameStatus === "error" ? true : false}
              success={
                employeeData?.projectNameStatus === "success" ? true : false
              }
              disabled={inputDisbled}
            />
            {employeeData?.projectNameStatus === "error" && (
              <FormControl error>
                <FormHelperText>Project Name is mandatory.</FormHelperText>
              </FormControl>
            )}
          </Grid>
        </Grid>
      </MaterialBox>
    </>
  );
};

export default OnsiteEmployeeDetails;
